'use client';

import { useIntl } from 'react-intl';
import { Skeleton } from '@packages/shared/src/ui/Skeleton/Skeleton';
import { Button } from '@packages/shared/src/ui/Button/Button';

export type AddReviewCallToActionProps = {
  /* 
    onAction - handler function that will be executed after a component action
  */
  onAction: () => void;
  /* 
    isLoading - indicates if the component should be rendered in loading state (Skeleton mode)
  */
  isLoading?: boolean;
};

/**
 * The AddReviewCallToAction component is used to display a call to action for the user
 * to write a new rating/review
 */
export const AddReviewCallToAction = ({
  onAction,
  isLoading = false,
}: AddReviewCallToActionProps) => {
  const { formatMessage } = useIntl();

  const handleAction = () => {
    if (typeof onAction === 'function') {
      onAction();
    }
  };

  if (isLoading) {
    return <Skeleton className="h-4.5 w-full" />;
  }

  return (
    <Button onClick={handleAction} className="w-full">
      {formatMessage({
        id: 'customerReviews.addReviewCallToAction.text',
        defaultMessage: 'Verfasse eine Bewertung',
      })}
    </Button>
  );
};
